import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { PriceIndexChartContext } from '../contexts/StoreContext'
import { PriceIndexChartStore } from '../store/interface'

export const usePriceIndexChartStore: UseStore<
  PriceIndexChartStore
> = selector => {
  return useContextStore(PriceIndexChartContext, selector)
}

export const usePriceIndexChartStoreApi = () => {
  return useContextStoreApi(PriceIndexChartContext)
}
